<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1049.6 1049.6"
    class="svg-icon icon"
  >
    <path
      id="circle"
      class="cls-1"
      d="M539.41,14.77c289.65,0,524.8,235.15,524.8,524.8s-235.15,524.8-524.8,524.8S14.61,829.21,14.61,539.57s235.16-524.8,524.8-524.8Zm0,56c258.75,0,468.83,210.07,468.83,468.83S798.16,1008.4,539.41,1008.4,70.58,798.32,70.58,539.57,280.66,70.74,539.41,70.74Z"
      transform="translate(-14.61 -14.77)"
    />
    <path
      id="black_card"
      data-name="black card"
      class="cls-1"
      d="M714.64,235.06H365a60.66,60.66,0,0,0-60.66,60.66V784.28A60.66,60.66,0,0,0,365,844.94H623.13a27.24,27.24,0,0,0,19.63-8.36l124.94-130a27.26,27.26,0,0,0,7.6-18.87v-392A60.66,60.66,0,0,0,714.64,235.06ZM535.47,284.49a83.13,83.13,0,1,1-83.12,83.13A83.14,83.14,0,0,1,535.47,284.49ZM439.93,645.65c-18.54,0-33.44-10.87-33.44-23.92,0-49.48-10.13-89.86,42.32-119.93,31.34-18.52,67.65-21.05,109.4-18.52,47.3,0,106.25,33.76,106.25,82.41,0,61.3,1,59.25-2.87,65.67C649.65,650.29,641.63,645.65,439.93,645.65ZM716.82,695l-93.28,93.55a7.29,7.29,0,0,1-12.44-5.14V706.33a23.76,23.76,0,0,1,23.75-23.75h76.81A7.28,7.28,0,0,1,716.82,695Z"
      transform="translate(-14.61 -14.77)"
    />
  </svg>
</template>

<script>
export default {
  name: "IconSwipeCandidates"
};
</script>

<style scoped>
.cls-1 {
  fill-rule: evenodd;
}
</style>
